const PropertyImagePlaceholder = ({ label = "Image coming soon" }) => (
  <div className="property-image-placeholder" aria-hidden="true">
    <span>{label}</span>
  </div>
);

export default PropertyImagePlaceholder;
